const $j = (typeof window !== 'undefined' && window.$j) || (() => {});
const loader_delay = window.loader_delay ?? 200;
const loader_fadeout = window.loader_fadeout ?? 300;
const getRandomInt = (typeof window !== 'undefined' && window.getRandomInt) || (() => 300);

const bLazy = new Blazy({
    success(el) {
        setTimeout(() => {
            const parent = el.parentNode;
            const loader = parent?.querySelector('.img-loader');
            if (typeof loader !== 'undefined' && loader != null && typeof loader.parentNode !== 'undefined' && loader.parentNode != null) {
                loader.style.opacity = '0';
                el.classList.remove('preload');
                setTimeout(() => {
                    if (typeof loader !== 'undefined' && loader != null && typeof loader.parentNode !== 'undefined' && loader.parentNode != null) {
                        loader.parentNode.removeChild(loader);
                    }
                }, 750);
            }
        }, getRandomInt(100, 600));
    },
    error(el, msg) {
        if (msg === 'missing' || msg === 'invalid') {
        }
    },
});

export function loader() {
    if (!!$j('.main-content').length) {
        $j('.main-content').fadeTo(250, 1);
    }
    if (!!$j('div.loader').length) {
        setTimeout(() => {
            $j('div.loader').fadeOut(loader_fadeout);
        }, loader_delay);
    }
    if (!!$j('.preload').length) {
        setTimeout(() => {
            $j('.preload').fadeTo(300, 1).removeClass('preload');
        }, loader_delay + 100);
    }
    bLazy.revalidate();
    setTimeout(() => bLazy.revalidate(), 7500);
    $j('.hero.multi').css({
        height: parseInt($j('.hero').height(), 10),
        overflow: 'hidden',
    });
}
